import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { agentsHistoricalFromAPIMapper } from '@shared/utils/mappers/geo-api-map';
import {
  GeometryTypeEnum,
  ILayerModel,
} from '@types-custom/models/business/marker.model';
import { Icon } from '@types-custom/models/ui/icon-model';
import { Observable } from 'rxjs';
import { formatDate } from '@angular/common';
@Injectable({
  providedIn: 'root',
})
export class AgentsService {
  constructor(
    private httpClient: HttpClient,
    @Inject('environment') private environment: any
  ) {}

  getAgentsGeoJSON(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.environment.agentsUrl}/agents/format-geo-json`
    );
  }

  getMeasurementAgents(): Observable<any> {
    //return this.httpClient.get<any>('assets/mock/activeAgentsByHour.json');
    return this.httpClient.get<any>(
      `${this.environment.agentsUrl}/agents-history/last-measurements`
    );
  }

  getAgentsHistoricalGeoJSON(): Observable<any> {
    // return this.httpClient.get<any>('assets/mock/agentsHistorical.json');
    return this.httpClient.get<any>(
      `${this.environment.agentsUrl}/agents-history/format-geo-json?hours=24`
    );
  }
  getAgentsMapper(agentsHistorical: any): ILayerModel[] {
    const layer: ILayerModel[] = [];

    const sourceFeatures = agentsHistorical.features
      .map((e: any) => {
        return {
          ...e,
          properties: {
            ...e.properties,
            id: String(e.properties.id),
            time: formatDate(e.properties.time, 'YYYY-MM-dd HH:mm:ss', 'en-US'),
            title: formatDate(e.properties.time, 'YYYY-MM-dd HH:mm:ss', 'en-US'),
            icon: Icon.dot,
          },
        };
      })
      .sort((a: any, b: any) =>
        a.properties.time.localeCompare(b.properties.time)
      );

    const source: any = { type: 'FeatureCollection', features: sourceFeatures };

    const agentsHistoryPoints = source.features.map((e: any) =>
      agentsHistoricalFromAPIMapper(e)
    );

    const agentsHistoryLines = this.getAgentsLinesHistorical(source).map(
      (e: any) => agentsHistoricalFromAPIMapper(e)
    );

    layer.push({
      marker: agentsHistoryPoints,
      geometryType: GeometryTypeEnum.HeatMap,
      feature: source,
      visibility: true,
    });

    layer.push({
      marker: agentsHistoryPoints,
      geometryType: GeometryTypeEnum.Point,
      feature: source,
      visibility: false,
    });

    layer.push({
      marker: agentsHistoryLines,
      geometryType: GeometryTypeEnum.LineString,
      feature: source,
      visibility: false,
    });

    return layer;
  }

  getAgentsLinesHistorical(data: any): any[] {
    const agentsIds = [
      ...new Set(data.features.map((e: any) => e.properties.id)),
    ];

    const agentsLineFeatures = [];

    for (const item of agentsIds) {
      const coordinates = data.features
        .filter((e: any) => e.properties.id === item)
        .map((e: any) => e.geometry.coordinates);

      const properties = data.features.filter(
        (e: any) => e.properties.id === item
      )[0].properties;

      const agentsLineFeature = {
        type: 'Feature',
        properties: properties,
        geometry: {
          type: GeometryTypeEnum.LineString,
          coordinates: coordinates,
        },
      };
      agentsLineFeatures.push(agentsLineFeature);
    }

    return agentsLineFeatures;
  }
}
